import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { of } from 'rxjs';

export const AccountVerificationGuard: CanActivateChildFn = (route) => {
	const authService = inject(AuthenticationService);
	const router = inject(Router);

	const user = authService.getUser();

	if (user === null) {
		// User authenticated but no profile found - redirect to account issue
		router.navigate(['/account-issue']);
		return of(false);
	}

	return of(true);
};
